<div style="width: 300px !important">
    <h3 style="margin: 0px 0px 7px 5px">{{ text | translate }}</h3>
    <p style="margin: 0px 0px 0px 5px;height:75px;">{{ description | translate }}</p>
</div>
